var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewTicket({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 24.2903L6.83872 27.2178C8.40651 25.601 10.9484 25.601 12.5162 27.2178C14.0839 28.8345 14.0839 31.4558 12.5162 33.0726L15.3549 36L29.0323 21.8952L26.9678 19.7661L28 18.7016L30.0645 20.8307L36 14.7097L33.1613 11.7823C31.5935 13.399 29.0517 13.3991 27.4839 11.7823C25.9161 10.1655 25.9161 7.54419 27.4839 5.92743L24.6452 3L18.7097 9.12098L20.7742 11.25L19.7419 12.3145L17.6774 10.1855L4 24.2903ZM14.3226 17.9032L17.6935 19.3836L20.5 16.8221L20.1049 20.6227L23.2661 22.5189L19.6452 23.3921L18.7984 27.1263L16.9597 23.8662L13.2742 24.2737L15.7581 21.3795L14.3226 17.9032ZM20.7742 13.379L21.8064 12.3145L23.871 14.4435L22.8387 15.5081L20.7742 13.379ZM23.871 16.5726L24.9032 15.5081L26.9678 17.6371L25.9355 18.7016L23.871 16.5726Z",
    fill: "#F3AA41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTicket);
export default __webpack_public_path__ + "static/media/newTicket.e64eb4c39358b51a04a43812cf0a2e84.svg";
export { ForwardRef as ReactComponent };